import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import axios from 'axios'
import { api } from '../../utils/api'
import { useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { getFromStorage } from '../../utils/storage'
import { Card, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { mainGreen } from '../../utils/color'

export default function SignUpStore() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [signUpData, setSignUpData] = useState({
		values: {
			name: '',
		},
		errors: {
			name: '',
		},
	})

	const handleChange = (e) => {
		let { name, value } = e.target
		let newValue = { ...signUpData.values, [name]: value }
		let newError = { ...signUpData.errors }

		if (name === 'name')
			if (value.trim() === '') {
				newError[name] = '* Tên cửa hàng không được để trống!'
			} else {
				newError[name] = ''
			}

		setSignUpData({ values: newValue, errors: newError })
	}

	const registerStore = async function (data) {
		try {
			const response = await axios({
				method: 'POST',
				url: api.SIGNUP_STORE_ADMIN,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data,
			})
			alert(response.data.message)
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const handleSubmit = (event) => {
		event.preventDefault()

		if (signUpData.errors.name !== '') {
			return
		}

		const name = signUpData.values.name

		const registerData = {
			name,
		}
		registerStore(registerData)
		navigate('/admin/stores')
	}

	return (
		<UserLayout>
			<Container sx={{ marginTop: '20px' }} maxWidth='sm'>
				<CssBaseline />
				<Card sx={{ padding: '10px' }}>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
						}}>
						<Box component='form' onSubmit={handleSubmit} noValidate sx={{ mt: 1, width: '100%' }}>
							{signUpData.errors.name === '' ? (
								<TextField
									sx={{ background: '#fff' }}
									margin='normal'
									required
									fullWidth
									id='name'
									label='Tên cửa hàng'
									name='name'
									autoComplete='name'
									autoFocus
									onChange={handleChange}
								/>
							) : (
								<TextField
									sx={{ background: '#fff' }}
									error
									margin='normal'
									required
									fullWidth
									id='name'
									label='Tên cửa hàng'
									name='name'
									autoComplete='name'
									autoFocus
									onChange={handleChange}
								/>
							)}
							<Typography sx={{ color: '#ff0000' }}>{signUpData.errors.name}</Typography>
							<Button
								type='submit'
								fullWidth
								variant='contained'
								sx={{
									mt: 3,
									mb: 2,
									background: mainGreen,
									'&:hover': { background: mainGreen },
								}}>
								Đăng ký
							</Button>
						</Box>
					</Box>
				</Card>
			</Container>
		</UserLayout>
	)
}
